import React, { Component } from 'react';
import { Link } from 'react-router';

import OrganizationSelect from "../../components/OrganizationSelect";
import Pagination from "../../components/Pagination";
import NodeStore from "../../stores/NodeStore";
import SessionStore from "../../stores/SessionStore";
import ApplicationStore from "../../stores/ApplicationStore";
import MessageBox from "../../components/MessageBox";
import CopyApplication from "../../components/CopyApplication";
import '../../index.css';



class SearchBox extends Component {
  constructor() {
    super();

    this.state = {
      searchText: "",
    };
  }

  onTextChange (e) {
    let v = e.target.value

    this.setState({
      searchText: e.target.value,
    });

    if (this.props.onSearch) {
      this.props.onSearch(v);
    }
  }

  render () {
    return (
      <div>
        <label>
          <input type="text" placeholder="input key to search" value={this.state.searchText || ''} onChange={this.onTextChange.bind(this)} /> &nbsp;&nbsp;&nbsp;&nbsp;
        </label>
      </div>
    );
  }
}

class NodeRow extends Component {
  formatGPS(gps) {
    const [latitude, longitude] = gps.split(',');
    const formattedLatitude = parseFloat(latitude).toFixed(3);
    const formattedLongitude = parseFloat(longitude).toFixed(3);
    return formattedLatitude+'...,'+formattedLongitude+'...'
  }

  render () {
    if (this.props.admin)
      this.td_sn = <Link to={`/organizations/${this.props.application.organizationID}/applications/${this.props.application.id}/nodes/${this.props.node.devEUI}/edit`}>{this.props.node.sn}</Link>;
    else
      this.td_sn = this.props.node.sn

    if (this.props.admin)
      this.td_eui = <Link to={`/organizations/${this.props.application.organizationID}/applications/${this.props.application.id}/nodes/${this.props.node.devEUI}/edit`}>{this.props.node.devEUI}</Link>;
    else
      this.td_eui = this.props.node.devEUI

    this.tds = [];

    if (this.props.needShow("sn"))
      this.tds.push(<td>{this.td_sn}</td>);

    this.tds.push(<td>{this.td_eui}</td>);

    if (this.props.needShow("meterReading"))
      this.tds.push(<td>{this.props.node.meterReading}</td>);

    if (this.props.needShow("recharge"))
      this.tds.push(<td>{this.props.node.recharge}</td>);

    if (typeof (this.props.application.exReading) !== "undefined") {
      let er = this.props.application.exReading;
      for (var i = 0; i < er.length; i++) {
        if (this.props.needShow(er[i].eid)) {
          var found = false;

          if (typeof (this.props.node.items) !== "undefined") {
            for (var k = 0; k < this.props.node.items.length; k++) {
              if (er[i].eid === this.props.node.items[k].id) {
                this.tds.push(<td>{this.props.node.items[k].value}</td>);
                found = true;
                break;
              }
            }
          }
          if (!found) {
            this.tds.push(<td></td>);
          }
        }
      }
    }

    if (typeof (this.props.application.rs485Config) !== "undefined" && typeof (this.props.application.rs485Config.reports) !== "undefined") {
      let reports = this.props.application.rs485Config.reports;

      for (i = 0; i < reports.length; i++) {
        if (this.props.needShow(reports[i].id)) {
          found = false;

          if (typeof (this.props.node.items) !== "undefined") {
            for (k = 0; k < this.props.node.items.length; k++) {
              if (reports[i].id === this.props.node.items[k].id) {
                this.tds.push(<td>{this.props.node.items[k].value}</td>);
                found = true;
                break;
              }
            }
          }
          if (!found) {
            this.tds.push(<td></td>);
          }
        }
      }
    }

    if (this.props.needShow("valve")){
      if (this.props.isRelay()) {
        if (this.props.node.valve === 'Open') {
          this.tds.push(<td>{'Connected'}</td>);
        }else if (this.props.node.valve === 'Close') {
          this.tds.push(<td>{'Disconnected'}</td>);
        }else{
          this.tds.push(<td>{this.props.node.valve}</td>); 
        }
      }else{
        this.tds.push(<td>{this.props.node.valve}</td>); 
      }
    }

    if (this.props.needShow("battery")) {
      this.tds.push(<td>{this.props.node.battery}</td>);
      this.tds.push(<td>{this.props.node.batteryLevel}</td>);
    }

    // console.log("--> need(lc)=", this.props.needShow("lc"), ", node=", this.props.node);

    if (this.props.needShow("lc")) {
      this.tds.push(<td>{this.props.node.lc1}</td>);
      this.tds.push(<td>{this.props.node.lc2}</td>);
      this.tds.push(<td>{this.props.node.lc3}</td>);
    }

    if (this.props.needShow("rssi"))
      this.tds.push(<td>{this.props.node.rssi}</td>);

    if (this.props.needShow("snr"))
      this.tds.push(<td>{this.props.node.snr}</td>);

    if (this.props.needShow("lastUpdate"))
      this.tds.push(<td>{this.props.node.lastUpdate}</td>);

    if (this.props.needShow("lastActive"))
      this.tds.push(<td>{this.props.node.lastActive}</td>);

    if (this.props.needShow("rebootCount"))
      this.tds.push(<td>{this.props.node.rebootCount}</td>);

    if (this.props.needShow("errCount"))
      this.tds.push(<td>{this.props.node.errCount}</td>);

    if (this.props.needShow("softVer"))
      this.tds.push(<td>{this.props.node.softVer}</td>);

    if (this.props.needShow("address")){
      if (this.props.node.gPS !== 'N/A') {
        if (this.props.node.address === '') {
          this.tds.push(<td><a href={`https://www.google.com/maps?q=${this.props.node.gPS}`} title={this.props.node.gPS} target="_blank">{this.formatGPS(this.props.node.gPS)}</a></td>);
        }else{
          this.tds.push(<td><a href={`https://www.google.com/maps?q=${this.props.node.gPS}`} title={this.props.node.gPS} target="_blank">{this.props.node.address}</a></td>);
        }
      }else{
        this.tds.push(<td>{this.props.node.address}</td>);
      }
    }

    if (this.props.needShow("MCUTemp"))
    this.tds.push(<td>{this.props.node.mCUTemp}</td>);

    return (
      <tr>
        {this.tds}
      </tr>
    );
  }
}

class ListNodes extends Component {
  static contextTypes = {
    router: React.PropTypes.object.isRequired
  };

  constructor() {
    super();
    this.state = {
      application: {},
      nodes: [],
      isAdmin: false,
      pageSize: 20,
      pageNumber: 1,
      pages: 1,
      currentSort: 'asc',
      currentSortkey: 'deveui',
      searchText: "",
      showModal: false,
      copyToAppID: null,
      copyToOrgID: null,
    };

    this.copyApplication = this.copyApplication.bind(this);
    this.copyApplicationShow = this.copyApplicationShow.bind(this);
    this.closeModal = this.closeModal.bind(this);

    this.onDelete = this.onDelete.bind(this);
    this.updatePage = this.updatePage.bind(this);
    this.needShow = this.needShow.bind(this);
    this.isRelay = this.isRelay.bind(this)
  }

  // 检查是否包含
  needShow (id) {
    let list = this.state.application.hideDisplay;

    if (typeof list === 'undefined')
      return true;

    for (var i in list) {
      if (list[i] === ('' + id))
        return false;
    }

    return true;
  }

  componentDidMount () {
    this.updatePage(this.props);
    ApplicationStore.getApplication(this.props.params.applicationID, (application) => {
      this.setState({ application: application });
    });

    this.setState({
      isAdmin: (SessionStore.isAdmin()
        || (SessionStore.isOrganizationAdmin(this.props.params.organizationID)
          || SessionStore.isApplicationAdmin(this.props.params.applicationID))),
    });

    SessionStore.on("change", () => {
      this.setState({
        isAdmin: (SessionStore.isAdmin()
          || (SessionStore.isOrganizationAdmin(this.props.params.organizationID)
            || SessionStore.isApplicationAdmin(this.props.params.applicationID))),
      });
    });

    this.startTimer()
  }

  startTimer () {
    this.TimerID = setInterval(() => {
      this.updatePage(this.props);
    }, 5000);
  }

  stopTimer () {
    if (this.TimerID !== undefined) {
      clearInterval(this.TimerID);
      this.TimerID = undefined
    }
  }

  componentWillUnmount () {
    this.stopTimer()
  }
  componentWillReceiveProps (nextProps) {
    this.updatePage(nextProps);
  }

  onSearchCallback (text) {
    this.stopTimer()
    this.setState({
      searchText: text,
    }, () => {
      this.updatePage(this.props);
      this.startTimer()
    });
  }

  onSortClick = (key) => {
    const currentSort = this.state.currentSort;
    const currentKey = this.state.currentSortkey;

    this.stopTimer()

    let nextSort;

    if (key === currentKey) {
      if (currentSort === 'asc') {
        nextSort = 'desc';
      } else {
        nextSort = 'asc';
      }
    } else {
      nextSort = 'asc';
    }

    this.setState({
      currentSortkey: key,
      currentSort: nextSort,
    }, () => {
      this.updatePage(this.props);
      this.startTimer()
    });
  };

  updatePage (props) {
    const page = (props.location.query.page === undefined) ? 1 : props.location.query.page;

    let desc = 0
    if (this.state.currentSort === "desc") {
      desc = 1
    }

    NodeStore.getAll(this.props.params.applicationID, this.state.pageSize, (page - 1) * this.state.pageSize, this.state.currentSortkey, desc, this.state.searchText, (totalCount, nodes) => {
      this.setState({
        nodes: nodes,
        pageNumber: page,
        pages: Math.ceil(totalCount / this.state.pageSize),
      });
      //window.scrollTo(0, 0);
    });
  }

  onDelete() {
    if (confirm("Are you sure you want to delete this application?")) {
      const dialog = document.createElement('div');
      dialog.style.position = 'fixed';
      dialog.style.top = '50%';
      dialog.style.left = '50%';
      dialog.style.transform = 'translate(-50%, -50%)';
      dialog.style.backgroundColor = 'white';
      dialog.style.padding = '20px';
      dialog.style.border = '1px solid black';
      dialog.style.textAlign = 'center';
  
      const countdownElementDescription = document.createElement('p');
      countdownElementDescription.textContent = `Are you sure to delete it?`;
      countdownElementDescription.style.fontSize= '24px'
      countdownElementDescription.style.margin = '0';
      countdownElementDescription.style.color = 'red'
      dialog.appendChild(countdownElementDescription);
  


      const countdownElement = document.createElement('p');
      countdownElement.textContent = ` 10`;
      countdownElement.style.fontSize= '80px'
      countdownElement.style.color = 'red'
      countdownElement.style.margin = '0';
      dialog.appendChild(countdownElement);


      const confirmBtn = document.createElement('button');
      confirmBtn.textContent = 'Yes';
      confirmBtn.style.backgroundColor = '#cccccc';
      confirmBtn.style.color = '#999999';
      confirmBtn.style.marginRight = '10px';
      confirmBtn.style.cursor = 'not-allowed';
      confirmBtn.style.width = '100px';
      confirmBtn.style.height = '36px';
      confirmBtn.setAttribute('disabled', 'disabled');
      confirmBtn.disabled = true;
      confirmBtn.style.margin = '0';
      dialog.appendChild(confirmBtn);
  
      const cancelBtn = document.createElement('button');
      cancelBtn.style.width = '100px';
      cancelBtn.style.height = '36px';
      cancelBtn.textContent = 'Cancel';
      cancelBtn.style.margin = '0';
      cancelBtn.style.marginLeft = '10px'
      dialog.appendChild(cancelBtn);
  
      document.body.appendChild(dialog);
  
      let countdown = 10;
  
      const timer = setInterval(() => {
        countdown--;
        countdownElement.textContent = `${countdown}`;
        if (countdown <= 0) {
          clearInterval(timer);
          confirmBtn.disabled = false;
          confirmBtn.style.backgroundColor = '#0061E0';
          confirmBtn.style.color = 'white';
          confirmBtn.style.cursor = 'default';
          countdownElementDescription.style.marginBottom = '40px';
          countdownElementDescription.textContent = 'Are you sure to delete it?'
          countdownElement.textContent = '';
        }
      }, 1000);
  
      confirmBtn.addEventListener('click', () => {
        ApplicationStore.deleteApplication(this.props.params.applicationID, (responseData) => {
          this.context.router.push("/organizations/" + this.props.params.organizationID + "/applications");
        });
        document.body.removeChild(dialog);
      });
  
      cancelBtn.addEventListener('click', () => {
        document.body.removeChild(dialog);
      });
    }
  }

  addSortTh (array, key, label) {
    if (this.state.currentSortkey === key) {
      if (this.state.currentSort === "asc") {
        array.push(<th><button type="button" onClick={this.onSortClick.bind(this, key)} className={"btn btn-xs btn-link"}>{label}<span className="glyphicon glyphicon-triangle-top text-primary"></span></button></th>);
      } else {
        array.push(<th><button type="button" onClick={this.onSortClick.bind(this, key)} className={"btn btn-xs btn-link"}>{label}<span className="glyphicon glyphicon-triangle-bottom text-primary"></span></button></th>);
      }
    } else {
      array.push(<th><button type="button" onClick={this.onSortClick.bind(this, key)} className={"btn btn-xs btn-link"}>{label}</button></th>);
    }
  }

  handleCopyToChange(id,filed){
    if (filed === "app") {
      this.setState({ copyToAppID: id });
    }else if (filed === "org") {
      this.setState({ copyToOrgID: id });
    }
  }

  copyApplicationShow() {
    if (this.state.copyToOrgID === null) {
      MessageBox.showAlert("Cannot be copied to other organization","warning")
      return
    }
    this.setState({ showModal: true });
  }

  closeModal() {
    this.setState({ showModal: false });
  }

  copyApplication() {
    if (confirm("Are you sure to copy this application into another organization?")){
      this.setState({ showModal: false });
    
      ApplicationStore.CopyApplication({from: this.state.application.id,toOrgID: this.state.copyToOrgID,toAppID:this.state.copyToAppID},(responseData) => {
        MessageBox.showAlert("Copy Success","success")
      })
    }
  }

  isRelay() {
    if (this.state.application.appType === 4) {
      return true
    }

    if (typeof (this.state.application.exReading) !== "undefined") {
      let er = this.state.application.exReading;
      for (var i = 0; i < er.length; i++) {
        if (this.needShow(er[i].eid)) {
          var s = er[i].name;
          if (s && /current|voltage|powerfactor|I\(/i.test(s)) {
              // s 包含指定词语
              return true
          }
          if (typeof (er[i].unit) !== "undefined" && er[i].unit !== "") {
            if (er[i].unit === 'A' || er[i].unit === 'V') {
              return true
            }
          }
        }
      }
    }
  }

  render () {
    const NodeRows = this.state.nodes.map((node, i) =>
      <NodeRow key={node.devEUI} node={node} application={this.state.application} isRelay={this.isRelay} needShow={this.needShow} admin={this.state.isAdmin} />);

    this.ths = [];

    if (this.needShow("sn"))
      this.addSortTh(this.ths, "sn", "Serial number")

    this.addSortTh(this.ths, "deveui", "Device EUI")

    if (this.needShow("meterReading"))
      this.addSortTh(this.ths, "meterReading", "Meter reading")

    if (this.needShow("recharge")) {
      this.addSortTh(this.ths, "recharge", "Prepayment")
    }

    if (typeof (this.state.application.exReading) !== "undefined") {
      let er = this.state.application.exReading;
      for (var i = 0; i < er.length; i++) {
        if (this.needShow(er[i].eid)) {
          var s = er[i].name;
          if (typeof (er[i].unit) !== "undefined" && er[i].unit !== "") {
            s += "(" + er[i].unit + ")";
          }
  
          this.ths.push(<th>{s}</th>);
        }
      }
    }

    if (typeof (this.state.application.rs485Config) !== "undefined" && typeof (this.state.application.rs485Config.reports) !== "undefined") {
      let reports = this.state.application.rs485Config.reports;

      for (i = 0; i < reports.length; i++) {
        if (this.needShow(reports[i].id)) {
          this.ths.push(<th>{reports[i].name}</th>);
        }
      }
    }

    if (this.needShow("valve")) {
      if (this.isRelay()) {
        this.addSortTh(this.ths, "valve", "Relay")
      }else{
        this.addSortTh(this.ths, "valve", "Valve")
      }
    }

    if (this.needShow("battery")) {
      this.addSortTh(this.ths, "battery", "Battery(V)")
      this.addSortTh(this.ths, "batteryPercent", "Battery(%)")
    }

    if (this.needShow("lc")) {
      this.addSortTh(this.ths, "lc1", "LC1")
      this.addSortTh(this.ths, "lc2", "LC2")
      this.addSortTh(this.ths, "lc3", "LC3")
    }

    if (this.needShow("rssi")) {
      this.addSortTh(this.ths, "rssi", "RSSI")
    }

    if (this.needShow("snr")) {
      this.addSortTh(this.ths, "snr", "SNR")
    }

    if (this.needShow("lastUpdate")) {
      this.addSortTh(this.ths, "lastUpdate", "Data Time")
    }

    if (this.needShow("lastActive")) {
      this.addSortTh(this.ths, "lastActive", "Transimit Time")
    }

    if (this.needShow("rebootCount")) {
      this.addSortTh(this.ths,"rebootCount","Reboot")
      //this.ths.push(<th>Reboot</th>)
    }

    if (this.needShow("errCount")) {
      this.addSortTh(this.ths,"errCount","Error")
      //this.ths.push(<th>Error</th>)
    }

    if (this.needShow("softVer")) {
      this.addSortTh(this.ths, "softVer", "Software version")
    }

    if (this.needShow("address")) {
      this.addSortTh(this.ths, "address", "Address")
    }

    if (this.needShow("MCUTemp")) {
      this.addSortTh(this.ths, "MCUTemp", "Temperature")
    }
    return (
      <div>
        <ol className="breadcrumb">
          <li><Link to="/organizations">Organizations</Link></li>
          <li><OrganizationSelect organizationID={this.props.params.organizationID} /></li>
          <li><Link to={`/organizations/${this.props.params.organizationID}/applications`}>Applications</Link></li>
          <li>{this.state.application.name}</li>
          <li className="active">Nodes</li>
        </ol>
        <div className="clearfix">
          <div className="pull-left">
            <SearchBox onSearch={this.onSearchCallback.bind(this)}></SearchBox>
          </div>
          <div className="btn-group pull-right" role="group" aria-label="...">
            <Link className={(this.state.isAdmin ? '' : 'hidden')} to={`/organizations/${this.props.params.organizationID}/applications/${this.props.params.applicationID}/ota`}><button type="button" className="btn btn-default">OTA</button></Link> &nbsp;
            <Link to={`/organizations/${this.props.params.organizationID}/applications/${this.props.params.applicationID}/match/${(this.state.searchText === null || this.state.searchText === '') ? 'all' : this.state.searchText}/download`}><button type="button" className="btn btn-default">Download</button></Link> &nbsp;
            <Link className={(this.state.isAdmin ? '' : 'hidden')} to={`/organizations/${this.props.params.organizationID}/applications/${this.props.params.applicationID}/nodes/create`}><button type="button" className="btn btn-default">Create node</button></Link> &nbsp;
            <Link className={(this.state.isAdmin ? '' : 'hidden')} to={`/organizations/${this.props.params.organizationID}/applications/${this.props.params.applicationID}/edit`}><button type="button" className="btn btn-default">Edit application</button></Link> &nbsp;
            <Link className={(this.state.isAdmin ? '' : 'hidden')} to={`/organizations/${this.props.params.organizationID}/applications/${this.props.params.applicationID}/users`}><button type="button" className="btn btn-default">Share application</button></Link> &nbsp;
            <Link className={(this.state.isAdmin ? '' : 'hidden')}><button type="button" onClick={this.copyApplicationShow} className="btn btn-default">Copy application</button></Link> &nbsp;
            <Link className={(this.state.isAdmin ? '' : 'hidden')}><button type="button" className="btn btn-danger" onClick={this.onDelete}>Delete application</button></Link>
          </div>
        </div>
        <hr />
        <div className="panel panel-default">
          <div className="panel-body">
            <table className="table table-hover">
              <thead>
                <tr>
                  {this.ths}
                </tr>
              </thead>
              <tbody>
                {NodeRows}
              </tbody>
            </table>
          </div>
          <Pagination pages={this.state.pages} currentPage={this.state.pageNumber} pathname={`/organizations/${this.props.params.organizationID}/applications/${this.props.params.applicationID}`} />
        </div>
        <CopyApplication app={this.state.application} showModal={this.state.showModal} closeModal={this.closeModal} copyToAppID={this.setState.copyToAppID} copyApplication={this.copyApplication.bind(this)} onCopyToChange={this.handleCopyToChange.bind(this)}/>
      </div>
    );
  }
}

export default ListNodes;



// WEBPACK FOOTER //
// ./src/views/nodes/ListNodes.js